import { apiAxios } from "../../apiConfig";

export const getNewsArticles = async () => {
  try {
    const response = await apiAxios.get("/news/admin/all");

    return response.data;
  } catch (error) {
    console.error("Error fetching news articles:", error);
    throw error;
  }
};

export const createNewsArticle = async (payload) => {
  try {
    const response = await apiAxios.post("/news", payload);

    return response.data;
  } catch (error) {
    console.error("Error creating news article:", error);
    throw error;
  }
};

export const updateNewsArticle = async (articleId, payload) => {
  try {
    const response = await apiAxios.put(`/news/${articleId}`, payload);

    return response.data;
  } catch (error) {
    console.error("Error updating news article:", error);
    throw error;
  }
};

export const deleteNewsArticle = async (articleId) => {
  try {
    const response = await apiAxios.delete(`/news/${articleId}`);

    return response.data;
  } catch (error) {
    console.error("Error deleting news article:", error);
    throw error;
  }
};
